import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import type { Badge } from "../../types/api";

interface UserBadgesProps {
  badges?: Badge[];
  className?: string;
}

export function UserBadges({ badges, className }: UserBadgesProps) {
  if (!badges?.length) return null;

  const verifiedBadge = badges.find((b) => b.type === "verified");

  if (!verifiedBadge) return null;

  const awardedDate = new Date(verifiedBadge.awardedAt).toLocaleDateString(
    "en-US",
    {
      month: "long",
      year: "numeric",
    }
  );

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn("inline align-middle", className)}>
            <img
              src="/badges/verified.svg"
              alt="Verified"
              className="inline h-3.5 w-3.5 align-[-0.05em]"
            />
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p className="font-mono">Verified since {awardedDate}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
